/* eslint-disable @typescript-eslint/typedef */
import { Injectable, inject } from '@angular/core';
import { APP_ACTIONS, type AppActionsApi } from '@app/core/app.actions';
import { RxState } from '@rx-angular/state';
import { Timesheet, TimesheetEventItem, TimesheetEventItemPagination, TimesheetPagination } from '@timesheet/state/timesheet.types';
interface ITimesheetState {
  timesheets: Timesheet[];
  timesheet: Timesheet;
  pagination: TimesheetPagination;
  timesheetEventItems: TimesheetEventItem[];
  timesheetEventItemsPagination: TimesheetEventItemPagination;
  searchedEventItems: TimesheetEventItem[];

  dateFilter: 'all' | '3m' | 'yd' | 'custom' | null;
}

@Injectable({
  providedIn: 'root'
})
export class TimesheetState extends RxState<ITimesheetState> {
  protected readonly appActions: AppActionsApi = inject(APP_ACTIONS);

  timesheets = this.signal('timesheets');
  timesheet = this.signal('timesheet');
  pagination = this.signal('pagination');
  timesheetEventItems = this.signal('timesheetEventItems');
  timesheetEventItemsPagination = this.signal('timesheetEventItemsPagination');
  searchedEventItems = this.signal('searchedEventItems');

  dateFilter = this.signal('dateFilter');

  constructor() {
    super();
    this.hold(this.appActions.resetAll$, () => {
      this.reset();
    });
    this.set({ timesheets: [], timesheetEventItems: [], searchedEventItems: [] });
  }

  resetTimesheetEventItems() {
    this.set({ timesheetEventItems: [] });
  }

  resetSearchedEventItems() {
    this.set({ searchedEventItems: [] });
  }

  // Clear all timesheet related state
  reset(): void {
    this.set({
      timesheets: [],
      timesheet: null,
      pagination: null,
      timesheetEventItems: [],
      timesheetEventItemsPagination: null,
      searchedEventItems: [],
      dateFilter: null
    });
  }
}
